export default "__VITE_ASSET__8iQbu2KU__";